import {Component, OnInit,Input, NgZone,Output,EventEmitter} from '@angular/core';
import {CartService} from '../../../services/cart.service';
import {ProductsService} from '../../../services/products.service';
import {Cartitems2} from '../../../classes/cartitems';
import {Product} from '../../../classes/product';
import {Observable} from 'rxjs';
import {of} from 'rxjs/observable/of';
import { Router, ActivatedRoute,Params } from '@angular/router';
import {Inventory} from '../../../classes/inventory';
import {CommonService} from '../../../services/common.service';
import { ViewContainerRef } from '@angular/core';
import { MatSnackBar } from '@angular/material';

//import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.css']
})
export class ShoppingCartComponent implements OnInit {
  newarray = [];
  msg1: any;
  action: any;
  cart: Cartitems2[];
  totalitems: number;
  invStock = [];
  ucid: number;
  qty: number;
  delitemid: number;
  city_id = 1;
  public loading = false;
  imgpath: any = {};
  payable: number;
  discount: number;
  discprice: number;
  mrp: number;
  msg: any;
  uid: any;
  cartflag= 0;
  cartlength = 0;
  currentnotavailableproduct = [];
  constructor(private cartService: CartService, private productsService: ProductsService,
    private router: Router,private route: ActivatedRoute,
    public commonService: CommonService,
    private snackbar: MatSnackBar, vcr: ViewContainerRef, 
   // private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.commonService.setMenuFlag(1);
    const udata = this.commonService.getUserDataLocally();
    this.uid = udata.uid;
    this.cartflag = 0;
    this.cartService.totalcartitems.subscribe(totalcartitems=> {
      this.totalitems = totalcartitems;
      this.refreshcart();
    });
  }

  ngOnInit() {
  }

  refreshcart() {
    this.loading = true;
       this.cartService.getUserCartItems(this.uid)
       .subscribe(
         (cart: Cartitems2[]) => {
           this.loading = false;
           this.cart = cart;
           this.cartlength = this.cart.length;
           if ( this.cart.length > 0 ) {
             for ( let i = 0 ; i < this.cart.length; i++) {
               this.getimg(this.cart[i].sku, this.cart[i].id, this.cart[i].quantity, this.cart[i].mrp, this.cart[i].discprice);
             }
             this.firstCheck();
           }
         }
         );
     }


  getimg(sku, cid, qty, mrp, discprice) {
    this.productsService.getProductimagebySku(sku)
    .subscribe(
      (x) => {
        this.imgpath['id' + x[0].sku] = x[0].image;

        if(x[0].splprice > 0){
          var discount = x[0].price - x[0].splprice;
          this.newarray.push({'splprice': x[0].splprice, 'price': x[0].price, 'discount': discount });

      }  else {

        this.newarray.push({'splprice': x[0].price, 'price': x[0].price, 'discount': 0 });
      }

      if(this.newarray && this.newarray.length > 0){
        if (this.newarray[0].price !== mrp || this.newarray[0].splprice !== discprice) {
          console.log('in if', this.newarray[0].price, this.newarray[0].splprice, this.newarray[0].discount, qty, discprice, mrp);
         this.updateCartPrices(cid, this.newarray[0].price, this.newarray[0].splprice, this.newarray[0].discount, qty);
        } else {
          this.newarray = [];
          console.log('in else');
        }
      }

      });
  }

  updateCartPrices(id, price, splprice, discount, qty) {
    var payable = splprice * qty;
    this.newarray = [];
  this.productsService.updateCartPrices(id, price, splprice, discount, payable)
    .subscribe((x) => {
      this.cartService.getUserCartItems(this.uid)
      .subscribe(
        (data2) => {
          this.cart = data2;
        });
    }); 
  }

  getinvstatus() {
    let cartlencount = this.cart.length;
    for ( let i = 0 ; i < this.cart.length; i ++) {
      this.commonService.getInventoryDetails(this.cart[i].product_id, this.city_id)
      .subscribe(
        (x: Inventory[]) => {
          this.invStock.push(x[0]);
          cartlencount = cartlencount - 1;
          if (cartlencount === 0) {
            this.checkposibility();
          }
        });
    }
  }

checkposibility() {
  for (let j = 0 ; j < this.cart.length ; j++) {
    for (let i = 0 ; i < this.invStock.length ; i++) {
     if (this.cart[j].product_id === this.invStock [i] .product_id
    && (this.cart[j].quantity > this.invStock[i]. totalstock || this.invStock[i].status === 0)) {
      const extra =  this.invStock[i]. totalstock;
      const status = this.invStock[i].status;
      this.currentnotavailableproduct.push({'pid': this.cart[j].product_id, 'qty': extra, 'status': status});
      this.cartflag = this.cartflag + 1;
    }
  }
 }
 this.loading = false;
 if (this.cartflag === 0) {
  const flag = 2;
  this.commonService.setActivatepath(flag);
  this.router.navigate(['/store/checkout']);
 }else {
   this.msg1 = 'We Have some Limited Stock For your item. So please modify your cart and try again';
   this.openSnackBar();
 }
}
 myCartAddMethod(cid, sku, id) {
    this.loading = true;
    this.addmethod(sku);
  }

  myCartSubMethod(cid, sku, id) {
    this.loading = true;
    this.submethod(sku, id, cid);
  }


  myCartRemoveMethod(id){
    this.loading = true;
    this.delitemid = id;
    var position: number;
    var qty: number;
    for(let i = 0; i < this.cart.length; i++) {
      if(this.cart[i].id === this.delitemid) {
        position = i;
        qty = this.cart[i].quantity;
      }

    }
    this.cartService.deleteCart(id)
    .subscribe(
      () => {
        this.loading = false;
        this.cart.splice(position, 1);
        this.cartflag = 0;
        this.currentnotavailableproduct = [];
        this.invStock = [];
        this.refreshcart();
        this.handelCartitems(qty);
        this.msg1 = 'Item Deleted';
        this.openSnackBar();
      });
  }
  
 
  finalCheck() {
    this.loading = true;
    this.cartflag = 0;
    this.currentnotavailableproduct = [];
    this.invStock = [];
    this.getinvstatus();
}
firstCheck() {
  this.cartflag = 0;
  this.currentnotavailableproduct = [];
  this.invStock = [];
  this.getinvstatusFirstTime();
}
getinvstatusFirstTime() {
  let cartlencount = this.cart.length;
  for ( let i = 0 ; i < this.cart.length; i ++) {
    this.commonService.getInventoryDetails(this.cart[i].product_id, this.city_id)
    .subscribe(
      (x: Inventory[]) => {
        this.invStock.push(x[0]);
        cartlencount = cartlencount - 1;
        if (cartlencount === 0) {
          this.checkposibilityFirstTime();
        }
      });
  }
}
checkposibilityFirstTime() {
  for (let j = 0 ; j < this.cart.length ; j++) {
    for (let i = 0 ; i < this.invStock.length ; i++) {
     if (this.cart[j].product_id === this.invStock [i] .product_id
    && (this.cart[j].quantity > this.invStock[i]. totalstock || this.invStock[i].status === 0)) {
      const extra =  this.invStock[i]. totalstock;
      const status = this.invStock[i].status;
      this.currentnotavailableproduct.push({'pid': this.cart[j].product_id, 'qty': extra, 'status': status});
      this.cartflag = this.cartflag + 1;
    }
  }
 }
}
  clickMe() {
    this.msg = "";
  }
  addmethod(sku) {
    for (let i = 0; i < this.cart.length; i++) {
      if (this.cart[i].sku === sku) {
        this.qty = this.cart[i].quantity;
        this.discount = this.cart[i].discount;
        this.mrp = this.cart[i].mrp;
        this. qty = this.qty + 1;
        this. discprice = (this.mrp - this.discount);
        this.payable = this.discprice * this.qty;
        this.cartService.updateCartDetail(this.cart[i].id, this.mrp, this.discount, this.qty, this.discprice,
          this.cart[i].tax, this.payable, this.cart[i].user_id, this.cart[i].user_name, this.cart[i].product_name, this.cart[i].sku)
        .subscribe(
          (cart: Cartitems2[]) => {
            this.cart[i].quantity = this.qty;
            this.cart[i].discprice = this.discprice;
            this.cart[i].payable = this.payable;
            this.loading = false;
            this.increaseCartitems();
       } );

      }
    }
  }

  submethod(sku, id, cid) {
    for (let i = 0; i < this.cart.length ; i++)  {
      if (this.cart[i].sku === sku && this.cart[i].quantity > 0) {
        this.qty = this.cart[i].quantity;
        this.discount = this.cart[i].discount;
        this.mrp = this.cart[i].mrp;
        this. qty = this.qty - 1;

          this. discprice = (this.mrp - this.discount);

        this.payable = this.discprice * this.qty;
        this.cart[i].quantity = this.qty;
        this.cart[i].discprice = this.discprice;
        this.cart[i].payable = this.payable;
        this.cartService.updateCartDetail(this.cart[i].id, this.mrp, this.discount, this.qty, this.discprice,
          this.cart[i].tax, this.payable, this.cart[i].user_id, this.cart[i].user_name, this.cart[i].product_name,this.cart[i].sku)
        .subscribe(
          (cart: Cartitems2[]) => {
            this.cart[i].quantity = this.qty;
            this.cart[i].discprice = this.discprice;
            this.cart[i].payable = this.payable;
            this.loading = false;
            this.decreaseCartitems();
          } );
      }
      if (this.cart[i].sku === sku && this.cart[i].quantity === 0) {
        this.myCartRemoveMethod(cid);
      }
    }
  }
  increaseCartitems = () => {
    const  total = this.totalitems + 1;
  this.cartService.changeTotalCartItems(total);
  }
  decreaseCartitems = () => {
    const  total = this.totalitems - 1;
  this.cartService.changeTotalCartItems(total);
  }
  handelCartitems(qty) {
    const  total = this.totalitems - qty;
   this.cartService.changeTotalCartItems(total);
  }

  openSnackBar() {
    this.snackbar.open(this.msg1 , this.action,{
      duration: 4000,
    });
  }
}
